// extracted by mini-css-extract-plugin
module.exports = {"module4":"module4_module4__PJTHw","module4Container":"module4_module4Container__ByKV8"};